package com.shadowings.gero.data.lessons.chapter4
import com.shadowings.gero.data.lessons.inlineMeaning
import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.buildVocabQuizContent
import com.shadowings.gero.data.lessons.chapter1.getUni1Content
import com.shadowings.gero.data.lessons.chapter1.getUni2Content
import com.shadowings.gero.data.lessons.chapter2.getHieroAnimalsContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFoodContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFood2Content
import com.shadowings.gero.data.lessons.chapter2.getHieroHumansContent
import com.shadowings.gero.data.lessons.chapter3.getHieroVarieContent


import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.UniliteralExplanation
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_royal_names_intro
import gero.composeapp.generated.resources.exp_content_word_reading_and_meaning
import gero.composeapp.generated.resources.exp_title_word_name
import gero.composeapp.generated.resources.hiero_detail_title
import gero.composeapp.generated.resources.lesson_royal_names_title
import gero.composeapp.generated.resources.swipe_up

private val royalNameHieroIds = listOf("F4", "S34", "F35", "R4", "N5")
val royalNameWordIds = listOf("IMN", "HAT", "TWT", "ANKH")

fun getRoyalNamesContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {
    val intro = ExplanationContent(
        title = Res.string.lesson_royal_names_title,
        content = Res.string.exp_content_royal_names_intro,
        face = Faces.Happy,
        image = Res.drawable.swipe_up,
        imageSize = 0.35f
    )

    val hieroSlides = royalNameHieroIds.mapNotNull { code ->
        hiero.firstOrNull { it.gardinerCode == code }?.let { sign ->
            val ideogramma = sign.getIdeogramma(languageCode)
            val determinativo = sign.getDeterminativo(languageCode)
            val label = if (ideogramma != "-") ideogramma else determinativo
            UniliteralExplanation(
                id = code,
                title = Res.string.hiero_detail_title,
                titleArgs = listOf(label)
            )
        }
    }

    val wordSlides = royalNameWordIds.mapNotNull { wordId ->
        words.firstOrNull { it.id == wordId }?.let { word ->
            ExplanationContent(
                title = Res.string.exp_title_word_name,
                titleArgs = listOf(word.getMeaning(languageCode)),
                content = Res.string.exp_content_word_reading_and_meaning,
                contentArgs = listOf(
                    word.reading,
                    word.inlineMeaning(languageCode),
                    word.getNote(languageCode)
                ),
                face = Faces.Happy,
                composable = { MdCWord(word.gardiner, rtl = false, cart = false, size = 96.dp) },
                wordId = word.id
            )
        }
    }

    return buildList {
        add(intro)
        addAll(hieroSlides)
        addAll(wordSlides)
    }
}

fun getRoyalNamesQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val hieroSlides = royalNameHieroIds.mapNotNull { code ->
        hiero.firstOrNull { it.gardinerCode == code }?.let { sign ->
            val ideogramma = sign.getIdeogramma(languageCode)
            val determinativo = sign.getDeterminativo(languageCode)
            val label = if (ideogramma != "-") ideogramma else determinativo
            UniliteralExplanation(
                id = code,
                title = Res.string.hiero_detail_title,
                titleArgs = listOf(label)
            )
        }
    }

    val wordSlides = royalNameWordIds.mapNotNull { wordId ->
        words.firstOrNull { it.id == wordId }?.let { word ->
            ExplanationContent(
                title = Res.string.exp_title_word_name,
                titleArgs = listOf(word.getMeaning(languageCode)),
                content = Res.string.exp_content_word_reading_and_meaning,
                contentArgs = listOf(
                    word.reading,
                    word.inlineMeaning(languageCode),
                    word.getNote(languageCode)
                ),
                face = Faces.Happy,
                composable = { MdCWord(word.gardiner, rtl = false, cart = false, size = 96.dp) },
                wordId = word.id
            )
        }
    }

    val previousHieroContent = getUni1Content(hiero, words, languageCode) +
            getUni2Content(hiero, words, languageCode) +
            getHieroFoodContent(hiero, words, languageCode) +
            getHieroFood2Content(hiero, words, languageCode) +
            getHieroAnimalsContent(hiero, words, languageCode) +
            getHieroHumansContent(hiero, words, languageCode) +
            getHieroVarieContent(hiero, words, languageCode)

    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = hieroSlides,
        languageCode = languageCode,
        previousHieroContent = previousHieroContent
    ) +
            buildVocabQuizContent(
                explanations = wordSlides,
                words = words,
                languageCode = languageCode
            )
}


